import Vue from 'vue';
import axios from 'axios';

const id = 'cart-app';

const Cart = {
	Init() {
		/* eslint-disable */
		if (document.getElementById(id)) {
			new Vue({
				el: `#${id}`,
				data: {
					currentStep: 1,
					loading: false,
					appModel: {
						Campaigns: [],
						FullName: null,
						Organization: null,
						EmailAddress: null,
						PhoneNumber: null,
						Street: null,
						City: null,
						State: null,
						ZipCode: null,
						SpecialInstructions: null,
						CompleteUrl: null,
						ErrorUrl: null
					}
				},
				methods: {
					changeStep(step) {
						this.currentStep = step;
						document.getElementById(id).scrollIntoView({ behavior: "smooth", block: "start" });
					},
					placeOrder() {
						axios
						.post('/Educational-Materials/Order', this.appModel)
						.then(response => {
							document.location.href = '/Educational-Materials/Order/Complete';
						})
						.catch(error => {
							document.location.href = '/Educational-Materials/Order/Error';
						})
						.then(() => {
							this.loading = false;
						});
						return true;
					},
					quantityFocused(event) {
						event.target.select();
					},
					totalCampaignQuantity(campaignId) {
						let total = 0;
						this.appModel.Campaigns.forEach(campaign => {
							if (campaign.Id == campaignId) {
								campaign.CampaignItems.forEach(campaignItem => {
									campaignItem.Availability.forEach(culture => {
										if (culture.Quantity > 0) {
											total += parseInt(culture.Quantity);
										}
									});
								});
							}
						});
						return total;
					}
				},
				created() {
					this.loading = true;
					axios
						.get('/Educational-Materials/OrderForm', {
							params: {
								featuredCampaign: null
							}
						})
						.then(response => {
							this.appModel = response.data;
							setTimeout(() => {
								Cart.OpenAccordion();
							}, 500);
						})
						.catch(error => {
							// console.log(error);
						})
						.then(() => {
							this.loading = false;
						});
				},
				mounted() {
					this.$nextTick(() => {
						Cart.UpdateCartCount();
					});
				}
			});
		};
		/* eslint-enable */
	},
	OpenAccordion() {
		const { hash } = document.location;
		if (hash !== undefined && hash.length > 0) {
			$(`a[href='${hash}']`)
				.trigger('click')[0]
				.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
		}
	},
	UpdateCartCount() {
		axios
			.get('/Educational-Materials/Count', {})
			.then(response => {
				const orderMaterials = document.getElementById('nav-order-materials');

				if (response.data > 0) {
					orderMaterials.innerText = `My Materials (${response.data})`;
					orderMaterials.parentNode.classList.add('w--indicator');
				} else {
					orderMaterials.innerText = `Order Materials`;
					orderMaterials.classList.parentNode.remove('w--indicator');
				}
			})
			.catch(error => {
				// console.log(error);
			})
			.then(() => {
				// nothing
			});
	}
};

export default Cart;
